export const NotificationIcon = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8px"
    height="9px"
    fill="none"
    className="goToCalendarNotification"
  >
    <circle cx="4px" cy="4.5px" r="4px" fill="#FF7A14" />
  </svg>
)
